var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show())?_c('div',{staticClass:"errors-section",attrs:{"id":"errors"}},_vm._l((_vm.errors),function(error,index){return _c('p',{key:index,staticClass:"errorMessages mb-2"},[_vm._v(" "+_vm._s(error.message || error)+" ")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }